<modal-form-container
  title="Contacts in this message"
  className="md:w-[860px] lg:w-[960px]"
  [showModal]="open"
  (closeModalEvent)="closeModal()"
>
  @if (open) {
    <div class="sl">
      @if (selectedContacts.length > 0) {
        <div class="sl__bar">
          <app-search-input
            class="sl__search"
            placeholder="Search by name, number or email"
            [debounce]="200"
            (valueChange)="onSearch($event)"
          />

          <div class="sc__bulk">
            @if (confirmRemoveAll) {
              <span class="sc__confirm">Remove all {{ formatCount(selectedContacts.length) }}?</span>
              <button type="button" class="bk-btn bk-btn--ghost sc__btn" data-bulk="keep" (click)="cancelRemoveAll()">
                Keep them
              </button>
              <button type="button" class="bk-btn sc__btn sc__danger" (click)="removeAllSelection()">Remove all</button>
            } @else {
              @if (checkedContacts.length) {
                <button type="button" class="bk-btn bk-btn--ghost sc__btn" (click)="removeSelection()">
                  <span class="bk-sym" aria-hidden="true">person_remove</span>
                  Remove {{ formatCount(checkedContacts.length) }} from message
                </button>
              }
              <button type="button" class="bk-btn bk-btn--ghost sc__btn" data-bulk="remove-all" (click)="askRemoveAll()">
                Remove all
              </button>
            }
          </div>
        </div>

        @if (paginatedContacts.data.length) {
          <div class="bk-panel sc__panel">
            <data-table label="Contacts in this message" [seamless]="true" [resizable]="false" [maxHeight]="'420px'" [skeletonColumns]="5">
              <table class="bk-log">
                <thead>
                  <tr>
                    <th scope="col" class="sc__check">
                      <input
                        type="checkbox"
                        aria-label="Select every contact on this page"
                        [checked]="allContactsSelected"
                        (change)="toggleSelectAllContacts()"
                      />
                    </th>
                    <th scope="col">Name</th>
                    <th scope="col" class="sc__col-phone">Phone</th>
                    <th scope="col" class="sc__col-email">Email</th>
                    <th scope="col" class="sc__col-gender">Gender</th>
                  </tr>
                </thead>
                <tbody>
                  @for (contact of paginatedContacts.data; track $index) {
                    <tr>
                      <td class="sc__check">
                        <input
                          type="checkbox"
                          [attr.aria-label]="'Select ' + contactName(contact)"
                          [checked]="isContactChecked(contact)"
                          (change)="toggleSelectContact(contact)"
                        />
                      </td>
                      <td class="sc__name">
                        <span class="bk-msg">
                          <span class="bk-msg__subject">{{ contactName(contact) }}</span>
                          <span class="bk-msg__preview sc__phone-inline">{{ contact.primaryContactNumber || "No number" }}</span>
                        </span>
                      </td>
                      <td class="quiet sc__col-phone">{{ contact.primaryContactNumber || "—" }}</td>
                      <td class="quiet sc__col-email">{{ contact.emailAddress || "—" }}</td>
                      <td class="quiet sc__col-gender">{{ contact.gender || "—" }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </data-table>
          </div>

          <app-pagination
            [currentPage]="paginatedContacts.pagination.page - 1"
            [totalPages]="paginatedContacts.pagination.totalPages"
            [totalItems]="paginatedContacts.pagination.total"
            [pageSize]="pageSize"
            (onNext)="goToNextPage()"
            (onPrev)="goToPreviousPage()"
            (changePage)="updatePage($event)"
            (pageSizeChange)="onPageSizeChange($event)"
          />
        } @else {
          <p class="sl__empty">No contacts match “{{ term.trim() }}”.</p>
        }
      } @else {
        <p class="sl__empty">No contacts chosen. Choose Contacts in the Recipients section to pick people one by one.</p>
      }

      <div class="sl__foot">
        <button type="button" class="bk-btn bk-btn--primary" (click)="closeModal()">Done</button>
      </div>
    </div>
  }
</modal-form-container>
